import LocationListView from '@/modules/location/views/LocationListView';
import { ROUTES } from '@/enums';

export default [
    {
        path: '',
        name: ROUTES.LOCATION.LIST,
        component: LocationListView
    }
];
